import React from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

const FAQ: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">FAQ</h1>
      <p className="section-description">
        Manage frequently asked questions with comprehensive content management features, including categorization, ordering, and visibility controls.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <QuestionMarkCircleIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">FAQ Management</h3>
              <p className="feature-description">
                Handle FAQs with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit FAQ entries</li>
                <li>Set question and answer content</li>
                <li>Toggle FAQ activation</li>
                <li>Mark FAQs as featured</li>
                <li>Delete individual FAQs</li>
                <li>Bulk delete multiple FAQs</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <QuestionMarkCircleIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">FAQ Organization</h3>
              <p className="feature-description">
                Structure and manage FAQ content:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Category management</li>
                <li>Custom ordering</li>
                <li>Featured status</li>
                <li>Active status</li>
                <li>Rich text content</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <QuestionMarkCircleIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">FAQ List</h3>
              <p className="feature-description">
                View and manage FAQs in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Question (searchable, sortable)</li>
                <li>Category (searchable, sortable)</li>
                <li>Featured status (sortable)</li>
                <li>Active status (sortable)</li>
                <li>Order (sortable)</li>
                <li>Last update date (sortable)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <QuestionMarkCircleIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Content Management</h3>
              <p className="feature-description">
                Manage FAQ content and presentation:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Rich text editor for answers</li>
                <li>Category selection</li>
                <li>Order management</li>
                <li>Featured status toggle</li>
                <li>Active status toggle</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Keep questions clear and concise</li>
            <li>Provide detailed, helpful answers</li>
            <li>Use appropriate categories</li>
            <li>Set meaningful order for FAQs</li>
            <li>Mark important FAQs as featured</li>
            <li>Regularly review and update content</li>
            <li>Keep inactive FAQs archived</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default FAQ; 